@if (maskinInfo) {
  <div class="maskin-row">
    <div class="maskin-column">
      <rask-input label="{{texts.Nummer}}" value="{{maskinInfo.maskinnummer}}" [readonly]="true"></rask-input>
    </div>
    <div class="maskin-column">
      <rask-checkbox label="{{texts.Aktiv}}" [checked]="maskinInfo.aktiv" [(ngModel)]="maskinInfo.aktiv"
      [disabled]="true"></rask-checkbox>
    </div>
    <div class="maskin-column">
      <rask-input label="{{texts.GPXnummer}}" value="{{maskinInfo.gpxnummer}}" [readonly]="true"></rask-input>
    </div>
    <div class="maskin-column">
      <rask-input label="{{texts.Tillverkare}}" value="{{maskinInfo.tillverkare}}" [readonly]="true"></rask-input>
    </div>
    <div class="maskin-column">
      <rask-input label="{{texts.Maskingtyp}}" value="{{maskinInfo.maskintyp}}" [readonly]="true"></rask-input>
    </div>
    <div class="maskin-column">
      <rask-checkbox label="{{texts.Stanford}}" [checked]="maskinInfo.stanford2010"
      [(ngModel)]="maskinInfo.stanford2010" [disabled]="true"></rask-checkbox>
    </div>
    <div class="maskin-column">
      <rask-input label="{{texts.Version}}" value="{{maskinInfo.stanford2010Version}}" [readonly]="true"></rask-input>
    </div>
    <div class="maskin-column">
      <rask-checkbox label="{{texts.SkickaPinFil}}" [checked]="maskinInfo.skickaPinFilerForMassa"
      [(ngModel)]="maskinInfo.skickaPinFilerForMassa" [disabled]="true"></rask-checkbox>
    </div>
    <div class="maskin-column">
      <rask-checkbox label="{{texts.FilskickAktiv}}" [checked]="maskinInfo.filskickaAktivt"
      [(ngModel)]="maskinInfo.filskickaAktivt" [disabled]="true"></rask-checkbox>
    </div>
    <div class="maskin-column">
      <rask-checkbox label="{{texts.SenderApteringsfiler}}" [(ngModel)]="maskinInfo.senderApteringsfiler"
      [disabled]="true"></rask-checkbox>
    </div>
    <div class="maskin-column">
      <rask-checkbox label="{{texts.SenderProduktionsfiler}}" [(ngModel)]="maskinInfo.senderProduktionsfiler"
      [disabled]="true"></rask-checkbox>
    </div>
  </div>
}
@if (maskinInfo) {
  <div class="d-flex mb-3">
    <div class="maskin-info-action-container">
      <rask-button (click)="skickaAktuellaOIN()" color="secondary" aid="skickaAktuellaOIN"
      [disabled]="!canSend()">{{texts.SkickaAktuellaOIN}}</rask-button>
      <rask-info>
        Systemet söker fram aktuella/pågående arbetsordrar som maskinen är schemalagd på och skickar objektsfilerna
        (OIN/FOI) till maskinen.
        Aktuella filer skickas på nytt utan att först skapas om.
        OBS Om arbetsordern ligger för nattlig omkörning skapas filerna om direkt och skickas. Följer samma
        regelverk som när en extramaskin ansluter till en arbetsorder.
      </rask-info>
    </div>
    <div class="maskin-info-action-container">
      <rask-button (click)="skickaOmFiler()" color="secondary" aid="skickaApteringsfiler"
      [disabled]="!canSend()">{{texts.SkickaApteringsfiler}}</rask-button>
      <rask-info>
        Systemet söker fram aktuella/pågående arbetsordrar som maskinen är schemalagd på och skickar alla
        apteringsfiler till maskinen,
        både objekt- (OIN/FOI) och instruktionsfiler (PIN/FDI). Aktuella filer skickas på nytt utan att först skapas
        om.
        OBS Om arbetsordern ligger för nattlig omkörning skapas filerna om direkt och skickas. Följer samma
        regelverk som när en extramaskin ansluter till en arbetsorder.
      </rask-info>
    </div>
    <div class="maskin-info-action-container">
      <rask-button (click)="rensaLogg()" color="secondary" aid="rensaSandningslogg" [disabled]="!canEdit()"
      negative>{{texts.RensaLogg}}</rask-button>
      <rask-info>
        Tömmer alla rader i sändningsloggen för vald maskin. Används t ex vid hårddiskkrasch i en maskindator. Fyll
        maskinens bibliotek på nytt via knapp "Skicka alla aktuella filer".
      </rask-info>
    </div>
    <div class="ms-3 maskin-info-action-container">
      <rask-file-upload
        accept=".env,.oin,.foi,.pin,.fdi,.spi"
        (fileChange)="onFileChange(upload.files)"
        [disabled]="manualFileUploadDisabled$ | async"
        #upload
        [multiple]="true"
        containerClass="btn btn-primary file-button">
        <span>Skicka fil manuellt</span>
      </rask-file-upload>
      <rask-info>
        Skicka fil manuellt genom att välja en fil sparad på disk. Du kan skicka SF2010-filer (ENV, OIN, FOI, PIN,
        FDI, SPI).
      </rask-info>
    </div>
  </div>
}